import { TextureLoader, Color, Group, PlaneGeometry, MeshBasicMaterial, Mesh, SRGBColorSpace, NearestFilter } from "three"

export { FigurativeMark }

class FigurativeMark extends Group {
    #opacity = 1
    #box = new LogoBox()
    #plane = new LogoGrad()

    constructor() {
        super()

        this.#box.position.z = -1
        this.#plane.position.x = .75
        this.#plane.position.y = .5
        this.#plane.position.z = 1

        this.add(this.#box, this.#plane)
    }

    set opacity(value) {
        if (this.#opacity == value) return
        else this.#opacity = value;

        [this.#plane, this.#box].forEach(
            ({ material }) => {
                material.opacity = value
            })
    }

    get opacity() {
        return this.#opacity
    }

}

class LogoBox extends Mesh {
    static #texture() {
        const texture = new TextureLoader().load(
            new URL(
                '/src/assets/textures/logo_box.webp',
                import.meta.url
            )
        )
        texture.colorSpace = SRGBColorSpace
        texture.magFilter = NearestFilter

        return texture
    }

    constructor() {
        const geometry = new PlaneGeometry(2, 2)

        const material = new MeshBasicMaterial({
            color: window.matchMedia('(prefers-color-scheme: dark)').matches ? new Color(0xfefefe) : new Color(0x000000),
            transparent: true,
            alphaMap: LogoBox.#texture()
        })

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener("change", ({ matches }) => {
            material.color = matches ? new Color(0xfefefe) : new Color(0x000000)
            material.needsUpdate = true
        })

        super(geometry, material)
    }
}

class LogoGrad extends Mesh {
    static #texture() {
        const texture = new TextureLoader().load(
            new URL(
                '/src/assets/textures/logo_gradient.webp',
                import.meta.url
            )
        )
        texture.colorSpace = SRGBColorSpace
        texture.rotation = Math.PI / 4.5

        return texture
    }

    constructor() {
        const geometry = new PlaneGeometry(1.8, 1.8)

        const material = new MeshBasicMaterial({
            transparent: true,
            map: LogoGrad.#texture()
        })

        super(geometry, material)
    }
}